module.exports = __webpack_public_path__ + "static/img/sd1.6d9eee1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shitang/sd1.gif
// module id = sdMX
// module chunks = 6